export const targetFormInitialValues = {};

export const scheduleFormInitialValues = {};
